"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PatioDoorRepairServicesInSainteCatherine() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section data-section-id="252560" id="מטפל-סיעודי-בתל-אביב-פתרון-מיידי" className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/tel_aviv_caregiver_hero.png)] bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-white/60 backdrop-blur-sm"></div>

      {}
      <div className="relative z-10 w-full px-4 sm:px-6 md:px-8 py-12 md:py-20">
        <div className="max-w-4xl mx-auto text-center">
          {}
          <div ref={headlineRef} className={`transition-all duration-700 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h1 className="font-default text-4xl sm:text-5xl md:text-6xl font-bold text-primary mb-6 leading-tight">
              מטפל סיעודי בתל אביב תוך 5 שעות
            </h1>
            <p className="font-default text-lg sm:text-xl text-foreground/90 mb-8 max-w-2xl mx-auto">
              זקוקים לסיוע דחוף? אנו מספקים שירותי <Link to="/" className="text-primary font-semibold underline">מטפל סיעודי בבית</Link> המותאמים אישית לצרכי המשפחה שלכם בתל אביב והסביבה. הצוות המקצועי שלנו זמין למתן מענה מיידי בערים נוספות כמו <Link to="#" className="text-primary font-semibold underline">מטפל סיעודי בירושלים</Link>, <Link to="#" className="text-primary font-semibold underline">מטפל סיעודי בחיפה</Link> או <Link to="#" className="text-primary font-semibold underline">מטפל סיעודי ברמת גן</Link>. אנו מציעים גם <Link to="/CaregiverServicePagesPage" className="text-primary font-semibold underline">שירותי סיעוד פרטיים</Link> וכן <Link to="/NursingCareNowPage" className="text-primary font-semibold underline">סיוע סיעודי דחוף</Link>, כולל <Link to="/CaregiverServicePagesPage2" className="text-primary font-semibold underline">השגחה בבית חולים</Link> ברגעים הקריטיים ביותר. אם אתם מחפשים <Link to="/NursingCaregiverInRamatGanWithinHoursPage" className="text-primary font-semibold underline">מטפל סיעודי ישראלי</Link> מנוסה, אדיב ומקצועי, הגעתם למקום הנכון. אנו מתחייבים לליווי צמוד, יחס אישי וביטחון מלא ליקיריכם, תוך הקפדה על סטנדרטים גבוהים של טיפול וחמלה.
            </p>
            <p className="font-default text-base text-foreground/80 mb-8 max-w-2xl mx-auto">
              קראו עוד במאמרים שלנו: <Link to="/ProfessionalBlogPage" className="text-primary underline">זכויות סיעוד ביטוח לאומי</Link>, <Link to="/ProfessionalBlogPage" className="text-primary underline">איך לבחור מטפל סיעודי</Link>, <Link to="/ProfessionalBlogPage" className="text-primary underline">כמה עולה מטפל סיעודי</Link>, <Link to="/ProfessionalBlogPage" className="text-primary underline">השגחה בבית חולים – מה חשוב לדעת</Link>, וגם <Link to="/ProfessionalBlogPage" className="text-primary underline">טיפים לטיפול בקשישים</Link>.
            </p>
          </div>

          {}
          <div ref={ctaRef} className={`transition-all duration-700 delay-200 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} flex flex-col sm:flex-row gap-4 justify-center items-center`}>
            <Button className="px-8 py-3 text-base font-semibold rounded-lg hover:shadow-lg transition-all bg-primary text-primary-foreground">
              <Link to="/ContactPage" className="flex items-center">
                הזמינו מטפל עכשיו
              </Link>
            </Button>
            <Button variant="secondary" className="px-8 py-3 text-base font-semibold rounded-lg bg-secondary text-secondary-foreground shadow-md">
              <Link to="/ProfessionalBlogPage" className="flex items-center">
                למידע על זכויות סיעוד
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}